"use client"

import { Suspense, useRef } from "react"
import { Canvas, useFrame } from "@react-three/fiber"
import { OrbitControls, Environment, Html } from "@react-three/drei"
import type { Mesh } from "three"

function ProductModel({ productType }: { productType: string }) {
  const meshRef = useRef<Mesh>(null)

  useFrame((state) => {
    if (meshRef.current) {
      meshRef.current.rotation.y = Math.sin(state.clock.elapsedTime * 0.5) * 0.1
    }
  })

  const getGeometry = () => {
    switch (productType) {
      case "Valves":
        return <cylinderGeometry args={[0.5, 0.7, 1.5, 8]} />
      case "Pipes":
        return <cylinderGeometry args={[0.3, 0.3, 2, 16]} />
      case "Plates & Sheets":
        return <boxGeometry args={[2, 0.1, 1.5]} />
      case "H-Iron":
        return <boxGeometry args={[0.2, 2, 1]} />
      case "Boxbars":
        return <boxGeometry args={[0.3, 0.3, 2]} />
      default:
        return <boxGeometry args={[1, 1, 1]} />
    }
  }

  return (
    <mesh ref={meshRef} position={[0, 0, 0]}>
      {getGeometry()}
      <meshStandardMaterial color="#475569" metalness={0.9} roughness={0.1} />
    </mesh>
  )
}

export default function ProductShowcase({ productType, className }: { productType: string; className?: string }) {
  return (
    <div className={`w-full h-64 ${className}`}>
      <Canvas camera={{ position: [3, 2, 3], fov: 50 }}>
        <Suspense fallback={<Html center>Loading...</Html>}>
          <ambientLight intensity={0.4} />
          <directionalLight position={[10, 10, 5]} intensity={1} />
          <ProductModel productType={productType} />
          <Environment preset="warehouse" />
          <OrbitControls enableZoom={false} autoRotate autoRotateSpeed={2} />
        </Suspense>
      </Canvas>
    </div>
  )
}
